import React from "react";
import QuillEditor from "./QuillEditor.jsx";
import { createEditedMedicalReport } from "../../../../services/api.js";
import { useSnackbarMessage } from "../../../Snackbar.jsx";

export default function MedicalReport({
  entry,
  fetchTimeline,
  selectedVersions,
  canEdit,
  clientId,
}) {
  const displaySnackbarMessage = useSnackbarMessage();

  const selId =
    selectedVersions[entry.report_group_id] ||
    entry.versions[entry.versions.length - 1]?.version_id;
  const selectedVersion =
    entry.versions.find((v) => v.version_id === selId) ||
    entry.versions[entry.versions.length - 1];

  return (
    <QuillEditor
      key={selectedVersion.version_id}
      initialHtml={selectedVersion?.report_text || ""}
      toolbarId={`id${selectedVersion?.version_id || entry.id}`}
      disabled={!selectedVersion?.isEditable || !canEdit}
      showEditButton={selectedVersion?.isEditable && selectedVersion?.is_latest}
      onSave={async (editedHtml) => {
        try {
          const latestVersion = entry.versions.find((v) => v.is_latest);
          if (!latestVersion) return;
          await createEditedMedicalReport({
            previous_id: latestVersion.version_id,
            client_id: clientId,
            report_type: entry.report_type,
            report_text: editedHtml,
          });
          displaySnackbarMessage({
            title: "Editace zápisu proběhla úspěšně.",
            content: "",
          });
          fetchTimeline();
        } catch (err) {
          console.error("Failed to save edited report:", err);
          displaySnackbarMessage({
            title: "Editace zápisu neproběhla.",
            severity: "error",
            content: err,
          });
        }
      }}
    />
  );
}
